module.exports = __webpack_public_path__ + "img/suupmolk_small.4472cfd4.png";